import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Cato} from '../components/dictionary/cato/cato';
import {of} from 'rxjs/observable/of';

@Injectable()
export class CatoService {

  constructor(private _http: HttpClient) {
  }

  getDictionaryById(id: string) {
    return this._http.get<any>('api/dictionary/cato/get/' + id);
  }

  getDictionaries(params: any, lang: number) {
    return this._http.post<any>('api/dictionary/cato/getAll/' + lang, params);
  }

  getAll() {
    return this._http.get<any>('api/dictionary/cato/getAll');
  }

  getTopAll() {
    return this._http.get<any>('api/dictionary/cato/getTopAll');
  }

  getFilteredCatos(param: any, lang: number) {
    return this._http.post<Cato[]>('api/dictionary/cato/getList/' + lang, param);
  }

  findListByIdOrName(search) {
    if (search === '' || !search || search.length < 3) {
      return of([]);
    }
    return this._http.post<Cato[]>('api/dictionary/cato/search/by/id/name', search);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/cato.service.ts